import multipleStringReplace from '@helpers/multiple-string-replace'
import generateCheckAvailDates from './generateCheckAvailDates'

const URL_TEMPLATES = {
	US: 'https://prf.hn/click/camref:1011lvW3Q/pubref:hoco-[cl_id]/ar:[pid]/destination:https://www.expedia.com/Hotel-Search?destination=[city]-[country]&startDate=[check_in]&endDate=[check_out]&adults=[adults]&children=[children]',
	GB: 'https://prf.hn/click/camref:1100lvTJF/pubref:hoco-[cl_id]/ar:[pid]/destination:https://www.expedia.co.uk/Hotel-Search?destination=[city]-[country]&startDate=[check_in]&endDate=[check_out]&adults=[adults]&children=[children]',
	TR: 'https://prf.hn/click/camref:1011lvW3E/pubref:hoco-[cl_id]-tr/ar:[pid]/destination:https://www.expedia.com/Hotel-Search?destination=[city]-[country]&startDate=[check_in]&endDate=[check_out]&adults=[adults]&children=[children]',
}

const { checkIn, checkOut } = generateCheckAvailDates()

const generateExpediaUrl = ({
	cl_id = shared.options.cl_id, // cluster id
	pid = shared.options.pid, // post id
	city = shared.options.dest_name, // city
	country = shared.options.country || '', // country
	country_code = shared.options.user?.country_code || '',
	dates = { checkIn, checkOut },
	adultsCount = 2,
	childrenAges = [],
}) => {
	const { checkIn: check_in, checkOut: check_out } = dates
	// Expedia expects "<room>_<age>" per child; we only ever book a single room, so room is always 1
	const children = childrenAges.map(age => `1_${age}`).join(',')

	try {
		const url = multipleStringReplace(URL_TEMPLATES[country_code], {
			cl_id,
			pid,
			city,
			country,
			check_in,
			check_out,
			adults: adultsCount,
			children,
		})

		return url
	} catch (error) {
		throw new Error(`Error while generating expedia url: ${error}`)
	}
}

export default generateExpediaUrl
